import { Injectable } from '@angular/core'
import { CanActivate, Router, ActivatedRoute } from '@angular/router'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const token: any = sessionStorage.getItem('api_token')
    if (token) {
      return true
    } else {
      window.location.href = JSON.parse(localStorage.getItem('baseUrl')).sso.url
    }
  }
}
